// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js!./metro-4.2.26-704-5bd053de31245.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("1c8729f6", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/metro-4.2.26-704-5bd053de31245.css
// module id = 2267
// module chunks = 0